// deps
import React, { memo } from "react";

// internal-deps
import { ItemAddons, ItemVariants, VEG_TYPE } from "@swiggy-private/cart-types";

// components
import FoodItemInfoV2 from "./FoodItemInfoV2";

export interface FoodItemInfoProps {
    className?: string;
    // name of item
    name: string;
    // optional subtext if any
    subText?: string;
    // is freebie item
    isFreebie: boolean;
    // if item can be cusomtised
    isCustomisable: boolean;
    // addons details
    addons: ItemAddons[];
    // variants details
    variants: ItemVariants[];
    // on click onCustomise Action
    onCustomise: VoidFunction;
    // quantity of item
    quantity: number;
    // item type text used for accessibility
    itemTypeText: string;
    // final price of item
    finalPrice: number;
    isGroupOrderFlow?: boolean;
    vegType: VEG_TYPE;
    isMerchItem?: boolean;
}

function FoodItemInfo({ ...restProps }: FoodItemInfoProps) {
    return <FoodItemInfoV2 {...restProps} />;
}

export default memo(FoodItemInfo);
